import { UnifiedVariant } from '@spotify-internal/encore-web/es/components/Type/Type';
import { CSSProperties } from 'react';

export type AdjustedVariantResult = {
  variant: UnifiedVariant;
  paddingBottom?: CSSProperties['paddingBottom'];
};

export const adjustVariant = (
  variant: UnifiedVariant,
): AdjustedVariantResult => {
  switch (variant) {
    case 'display1':
      return { variant: 'bass', paddingBottom: '0.67em' };
    case 'display2':
      return { variant: 'forte', paddingBottom: '0.67em' };
    case 'heading1':
      return { variant: 'altoBrio', paddingBottom: '0.67em' };
    case 'heading2':
      return { variant: 'alto', paddingBottom: '0.75em' };
    case 'heading3':
      return { variant: 'celloCanon' };
    case 'heading4':
      return { variant: 'cello' };
    case 'body1':
      return { variant: 'ballad' };
    case 'body2':
      return { variant: 'viola' };
    case 'body3':
    case 'body4':
      return { variant: 'finale' };
    case 'cta1':
    case 'cta2':
      return { variant: 'metronome' };
    case 'cta3':
      return { variant: 'minuetBold' };
    case 'cta4':
      return { variant: 'finaleBold' };

    default:
      return { variant };
  }
};
